import React, { Component, useEffect, useState, useRef } from "react";
import DialCode from './PaymentDetails/DialCode';
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import { setCustomerAgentLogin, getGeoInfo, registrationagentemailcheck } from './axios';
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./AgentSignup.css";

export default function AgentForgotCompleted() {
    return (
      <div id="login">
            <figure> <a href="/">
              <img src="images/logo/seyLogo.png" alt="Holiday Seychelles" className="logo_sticky" />
              </a>
            </figure> <br/>
            <div style={{textAlign: 'center', width: '700px', margin: 'auto'}}>
            <p style={{fontsSize:'20px'}} >We have sent an email with a link to your email address. Kindly click on the link to change your password.</p>
            <div class="btn btn-primary" style={{color: '#fff',
    backgroundColor: '#ed9853',
    borderColor: '#ec8c51',
    cursor: 'pointer', marginTop: '15px'}}><strong><a href="/" style={{color:'#fff'}}>Back To Home</a></strong></div>
 </div>
  </div>
        );
}